import { apolloClientHolder, FieldDescriptor, Utils } from "@crispico/foundation-react";
import { ModalExt } from "@crispico/foundation-react/components/ModalExt/ModalExt";
import { FieldRendererProps } from "@crispico/foundation-react/entity_crud/fieldRenderersEditors";
import { GalleryMedia } from "components/LiveVideo/GalleryMedia";
import gql from "graphql-tag";
import moment from "moment";
import { FILES_PATH, Video } from "pages/EquipmentResource/VideoTab";
import React, { ReactNode } from "react";
import { Button, Icon, Modal } from "semantic-ui-react";

export type DrivingEvent = {
    id: Number,
    type: String,
    date: String,
    longitude: Number,
    latitude: Number,
    equipmentResource: any;
}

export class VideoFieldRenderer extends FieldDescriptor {
    
    constructor(name: string) {
        super();
        this.name = name;
        this.icon = "film";
        this.clientOnly = true;
        this.filterable = false;
        this.sortable = false;
        this.isInDefaultColumnConfigForEditor = false;
    }

    getAppearsInUi(): boolean {
        return true;
    }

    protected renderFieldInternal(RendererClass: any, props: FieldRendererProps): ReactNode {
        return <> 
            <VideoFieldRendererComponent {...props} />
            </>
    }
}

class VideoFieldRendererComponent extends React.Component<FieldRendererProps, { modalOpen: boolean, videos?: { [key: string]: string; }}> {

    constructor(props: FieldRendererProps) {
        super(props);
        this.state = { modalOpen: false };
    }

    protected async getVideos(entity: DrivingEvent){ 
        const loadedVideos = {} as { [key: string]: string; }

        // maybe DE is created manual
        if (!entity.id || !entity.date || !entity.longitude || !entity.longitude || !entity.equipmentResource){
            return;
        }
        // date from client comes with milis "2022-04-13T11:55:06.101Z" and I need to remove ".101"
        // date after process "2022-04-13T11:55:06Z"
        const dateAndMilis = entity.date.split(".");
        var dateStr = dateAndMilis[0];

        // check if data comes with milis, if not I can add another "Z" which will be a mistake
        if (dateAndMilis.length == 2){
            dateStr = dateAndMilis[0] + "Z";
        }

        const query = gql(`query getVideos($equipmentResourceId: Long!, $startDate: Date, $endDate: Date){
            smartwitnessService_media(
                equipmentResourceId: $equipmentResourceId
                startDate: $startDate
                endDate: $endDate
            ) {date, thumbnailPath, videoPath, eventType, cameraChannel, entityId, latitude, longitude, duration}
          } `);
        
        const results: Video[] =  await ((await apolloClientHolder.apolloClient.query(
            { query, variables: { equipmentResourceId: entity.equipmentResource.id, startDate: dateStr, endDate: dateStr  }}))).data.smartwitnessService_media;
        
        // filter after DE id, maybe exists driving event with same information, but id must be unique
        results.forEach((result, index) => {
            if (result.entityId != entity.id.toString()){
                results.slice(index,1);
            } else {
                loadedVideos[result.cameraChannel] = FILES_PATH + result.videoPath;
            }
        })

        this.setState({videos: loadedVideos});
    }

    render() {         
        return <>
             <ModalExt open={this.state.modalOpen} style={{ width: '95%', height: '95%' }} onClose={() => {this.setState({modalOpen: false})}} >
                <Modal.Content className="wh100">
                    <GalleryMedia data={this.state.videos} loading={false} video={true} extraInfo={this.props.entity.type + " " + moment(this.props.entity.date).format(Utils.dateTimeWithSecFormat)}/>
                </Modal.Content>
            </ModalExt>
            <Button icon circular size="small" style={{transform: 'translate(50%, -10%)'}} onClick={() => {this.setState({modalOpen: true}); this.getVideos(this.props.entity);}}>
                <Icon name="play" color="red" />
            </Button>
        </>
    }
}